import * as React from "react";

export class Form {
         public static handleChange = (
           dispatch: React.Dispatch<React.SetStateAction<string>>
         ) => (
           event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
         ) => {
           const value = event.target.value;
           dispatch(value);
         };

         public static handleChangeProp = (
           dispatch: React.Dispatch<React.SetStateAction<any>>,
           name: string
         ) => (
           event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
         ) => {
           const value = event.target.value;
           dispatch((c: any) => {
             return { ...c, [name]: value };
           });
         };

         public static handleChangeCheck = (
           dispatch: React.Dispatch<React.SetStateAction<boolean>>
         ) => (
           event: React.ChangeEvent<HTMLInputElement>,
           checked: boolean
         ) => {
           dispatch(checked);
         };

         public static handleChangeSelect = (
           dispatch: React.Dispatch<React.SetStateAction<string>>,
           def?: string,
           chain?: (value: string) => void
         ) => (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
           const value = Boolean(event.target.value)
             ? (event.target.value as string)
             : def || "";
           dispatch(value);
           if (chain) {
             chain(value);
           }
         };
       }
